import { render, staticRenderFns } from "./CallCountStatisticsPage.vue?vue&type=template&id=391fb06c&scoped=true&"
import script from "./CallCountStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./CallCountStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391fb06c",
  null
  
)

export default component.exports